import axios from "axios";
import router from "@/router/index";

export default function auth({ to, next, store }) {
  var token = localStorage.getItem("token");
  var isAuthenticated = Boolean(token);

  if (isAuthenticated) {
    if (store.getters.auth) {
      next();
    } else {
      axios
        .get(axios.defaults.baseURL + "auth/current-user", {
          headers: {
            Authorization: "Bearer " + token,
            "ngrok-skip-browser-warning": "69420",
          },
        })
        .then((response) => {
          if (response.data.data[0].role[0] === "SAD") {
            let user = {
              admin: response.data.data[0].admin,
              createdAt: response.data.data[0].createdAt,
              email: response.data.data[0].email,
              firstName: response.data.data[0].firstName,
              profileLink: response.data.data[0].profileLink,
              lastName: response.data.data[0].lastName,
              role: response.data.data[0].role[0],
              status: response.data.data[0].status,
              updatedAt: response.data.data[0].updatedAt,
              _id: response.data.data[0]._id,
              token: token,
            };
            store.commit("SET_LOGIN_DETAILS", user);
            store.commit("SET_USER_AUTHS", { isLoggedIn: true, token: token });
            store.commit("SET_COMPONENT_LAYOUT", {
              layout: "SuperAdminLayout",
            });
            localStorage.setItem("user", JSON.stringify(user));
          } else {
            let user = {
              admin: response.data.data[0].admin,
              alternativeEmail: response.data.data[0].alternativeEmail,
              hasAccount: response.data.data[0].hasAccount,
              createdAt: response.data.data[0].createdAt,
              email: response.data.data[0].email,
              firstName: response.data.data[0].firstName,
              profileLink: response.data.data[0].profileLink,
              lastName: response.data.data[0].lastName,
              member: response.data.data[0].member,
              role: response.data.data[0].role,
              status: response.data.data[0].status,
              subscriptionStatus: response.data.data[0].subscriptionStatus,
              isTrial: response.data.data[0].isTrial,
              subscriptionDaysRemaining: response.data.data[0].subscriptionDaysRemaining,
              subscriptionExpiryDate: response.data.data[0].subscriptionExpiryDate,
              updatedAt: response.data.data[0].updatedAt,
              _id: response.data.data[0]._id,
              token: token,
            };
            store.commit("SET_LOGIN_DETAILS", user);
            store.commit("SET_COMPONENT_LAYOUT", { layout: "AdminLayout" });
            localStorage.setItem("user", JSON.stringify(user));

            // router.push("/admin")

            if (
              (user.subscriptionStatus === "Expired" || user.subscriptionStatus === "No Subscription") &&
              user.role === "AD"
            ) {
              // Don't mark fully logged-in yet - keep re-checking until they
              // actually have an active subscription
              return next("/pricing");
            } else if (
              (user.subscriptionStatus === "Expired" || user.subscriptionStatus === "No Subscription") &&
              user.role !== "AD"
            ) {
              // Members can't act on their admin's subscription themselves.
              // Clear the stored session so this doesn't silently re-trigger
              // on every future visit (which just bounced them back to
              // /login with no explanation), and tell them why.
              localStorage.removeItem("token");
              localStorage.removeItem("user");
              store.dispatch("checkErrorAndSendToast", [
                response.data.message,
                "success",
              ]);
              return next("/login");
            }

            store.commit("SET_USER_AUTHS", { isLoggedIn: true, token: token });
          }

          next();
        })
        .catch((err) => {
          if (err.response?.statusText == "Unauthorized") {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            return next({
              name: "Login",
            });
          }
          next();
        });
    }
  } else if (to.meta.portal === "Admin") {
    store.commit("SET_USER_AUTHS", { token: null, isLoggedIn: false });
    store.commit("SET_COMPONENT_LAYOUT", { layout: "AdminLayout" });
    // return next({
    //   name: "Login",
    // });
    router.push("/login");
  } else if (to.meta.portal === "SuperAdmin") {
    store.commit("SET_USER_AUTHS", { token: null, isLoggedIn: false });
    // return next({
    //   name: "Login",
    // });
    router.push("/login");
  }
}
